// THIS IS A GENERATED FILE
import * as Types from "../../../graphql/types"

import gql from "graphql-tag"
import * as ApolloReactCommon from "@apollo/react-common"
import * as ApolloReactHooks from "@apollo/react-hooks"

export type SsrLogsQueryVariables = Types.Exact<{
  siteId: Types.Scalars["UUID"]
  buildId: Types.Scalars["UUID"]
}>

export type SsrLogsQuery = { __typename?: "Query" } & {
  ssrLogs: Array<
    { __typename?: "Log" } & Pick<
      Types.Log,
      | "id"
      | "timestamp"
      | "message"
      | "sourceStream"
      | "command"
      | "invocationId"
    >
  >
}

export type SsrLogCreatedSubscriptionVariables = Types.Exact<{
  siteId: Types.Scalars["UUID"]
  buildId: Types.Scalars["UUID"]
}>

export type SsrLogCreatedSubscription = { __typename?: "Subscription" } & {
  ssrLogCreated?: Types.Maybe<
    { __typename?: "Log" } & Pick<
      Types.Log,
      | "id"
      | "timestamp"
      | "message"
      | "sourceStream"
      | "command"
      | "invocationId"
    >
  >
}

export const SsrLogsDocument = gql`
  query SsrLogs($siteId: UUID!, $buildId: UUID!) {
    ssrLogs(siteId: $siteId, buildId: $buildId) {
      id
      timestamp
      message
      sourceStream
      command
      invocationId
    }
  }
`

/**
 * __useSsrLogsQuery__
 *
 * To run a query within a React component, call `useSsrLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsrLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsrLogsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      buildId: // value for 'buildId'
 *   },
 * });
 */
export function useSsrLogsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    SsrLogsQuery,
    SsrLogsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<SsrLogsQuery, SsrLogsQueryVariables>(
    SsrLogsDocument,
    baseOptions
  )
}
export function useSsrLogsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    SsrLogsQuery,
    SsrLogsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<SsrLogsQuery, SsrLogsQueryVariables>(
    SsrLogsDocument,
    baseOptions
  )
}
export type SsrLogsQueryHookResult = ReturnType<typeof useSsrLogsQuery>
export type SsrLogsLazyQueryHookResult = ReturnType<typeof useSsrLogsLazyQuery>
export type SsrLogsQueryResult = ApolloReactCommon.QueryResult<
  SsrLogsQuery,
  SsrLogsQueryVariables
>
export const SsrLogCreatedDocument = gql`
  subscription SsrLogCreated($siteId: UUID!, $buildId: UUID!) {
    ssrLogCreated(siteId: $siteId, buildId: $buildId) {
      id
      timestamp
      message
      sourceStream
      command
      invocationId
    }
  }
`

/**
 * __useSsrLogCreatedSubscription__
 *
 * To run a query within a React component, call `useSsrLogCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSsrLogCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsrLogCreatedSubscription({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      buildId: // value for 'buildId'
 *   },
 * });
 */
export function useSsrLogCreatedSubscription(
  baseOptions?: ApolloReactHooks.SubscriptionHookOptions<
    SsrLogCreatedSubscription,
    SsrLogCreatedSubscriptionVariables
  >
) {
  return ApolloReactHooks.useSubscription<
    SsrLogCreatedSubscription,
    SsrLogCreatedSubscriptionVariables
  >(SsrLogCreatedDocument, baseOptions)
}
export type SsrLogCreatedSubscriptionHookResult = ReturnType<
  typeof useSsrLogCreatedSubscription
>
export type SsrLogCreatedSubscriptionResult = ApolloReactCommon.SubscriptionResult<
  SsrLogCreatedSubscription
>
